const routes = {
  path: '/wechat',
  component: () => import('@/components/layout/index.vue'), 
  meta: {
    title: '企业微信管理',
    icon: 'iconqiwei',
    permission: 'company'
  },
  children: [
    {
      path: 'enterprice/setting',
      name: 'EnterPriceSetting',
      component: () => import('@/views/enterpriceWechatManage/enterpriceWechatSetting/index'),
      meta: {
        title: '企微设置',
        permission: 'system.self-built-setting',
      }
    },
    {
      path: 'member/unactive/list',
      name: 'UnActiveMember',
      component: () => import('@/views/enterpriceWechatManage/unActiveMember/list.vue'),
      meta: {
        title: '企微成员',
        permission: 'company.not-active-user',
      }
    },
  ]
}
export default routes;